import { createLogger } from "redux-logger";
import storage from "redux-persist/lib/storage";
import { persistReducer, persistStore } from "redux-persist";
import { Action, combineReducers, configureStore, Middleware } from "@reduxjs/toolkit";

import alertSlice from "store/slices/alert-slice";
import profileSlice from "store/slices/profile-slice";

import CONSTANTS from "constants/constant";

import { RootStateDto } from "dto/redux/store-dto";

const persistConfig = {
	key: CONSTANTS.REDUX_ACTION.REDUX_PRESIST,
	storage,
};

const middlewares: Middleware[] = [];

if (process.env.NODE_ENV === "development") {
	const reduxLogger = createLogger({ collapsed: true });
	middlewares.push(reduxLogger);
}

const reducers = {
	alert: alertSlice,
	profile: profileSlice,
};

export const combinedReducers = combineReducers(reducers);

const rootReducer = (state: RootStateDto | undefined, action: Action) => {
	if (action.type === CONSTANTS.REDUX_ACTION.LOGOUT) state = undefined;
	return combinedReducers(state, action);
};

const persistedReducer = persistReducer(persistConfig, rootReducer);

const store = configureStore({
	reducer: persistedReducer,
	middleware: (getDefaultMiddleware) => getDefaultMiddleware({ serializableCheck: false }).concat(middlewares),
});

export const persistor = persistStore(store);

export default store;
